export const generateTourDefaultMessage = (
  userProfile: { id?: string },
  agentContactName: string,
  propertyAddress: string,
) =>
  userProfile?.id
    ? `Hi ${agentContactName}, 
I saw your listing and I’d like to schedule a tour for ${propertyAddress}. Please let me know if you’re available for a showing.`
    : `Hi ${agentContactName}, 
I’m interested in ${propertyAddress}. Could you please contact me?`

export const MESSAGE_TYPE = {
  PRE_SCREEN: 'pre-screen',
  SCHEDULE_TOUR: 'schedule-tour',
  MESSAGE: 'msg',
}
